import React, { useState, useEffect, useRef } from 'react';
import { useData } from "../backend/firebase";
import GoFundMeEmbed from '../components/GoFundMeEmbed';
import SEO from '../components/SEO';

const Donations = () => {
  const { donationsContent } = useData();
  const thankYouText = donationsContent?.thankYouText || "<p>A massive thank you to our community! All funds go directly to the prize pool.</p>";

  const [showFloater, setShowFloater] = useState(false);
  const mainCtaRef = useRef(null);

  useEffect(() => {
      const observer = new IntersectionObserver(
          ([entry]) => {
              // If the main CTA card is NOT on the screen, show the floater!
              setShowFloater(!entry.isIntersecting);
          },
          { threshold: 0.1 } // Triggers when less than 10% of the main card is visible
      );

      if (mainCtaRef.current) {
          observer.observe(mainCtaRef.current);
      }

      return () => {
          if (mainCtaRef.current) observer.unobserve(mainCtaRef.current);
      };
  }, []);

  return (
    <div className="PageLayout" style={{ height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <SEO title="Donations" description="Help us grow the prize pool for the content creators!" url="/donate" />
        
        <style>{`
            .page-header-title {
                display: block;
                text-align: center;
                width: 100%;
                font-size: 2.0rem;
                font-weight: 800;
                color: #FFFFFF;
                margin: 40px 0 20px 0;
                text-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
                flex-shrink: 0;
            }

            .donations-grid {
                display: flex;
                flex-direction: row; /* Desktop Side-by-Side */
                gap: 20px;
                width: 100%;
                max-width: 1100px;
                margin: 0 auto;
                align-items: flex-start;
            }
            .supporter-list {
                color: #A0AEC0;
                line-height: 1.6;
                font-size: 13px;
                text-align: center;
                column-count: 2; /* 2-column layout on Desktop */
                column-gap: 20px;
                margin-bottom: 15px;
            }

            .supporter-list > * {
                margin-top: 0 !important;
                padding-top: 0 !important;
                break-inside: avoid !important;
                page-break-inside: avoid !important;
            }

            .floating-donate-widget {
                display: none; /* Strictly hidden on desktop */
            }

            @media (max-width: 900px) {
                .donations-grid {
                    flex-direction: column-reverse; 
                    align-items: stretch; /* Forces cards to take full width and height on mobile */
                    gap: 30px; /* Adds a little more breathing room between the two cards when stacked */
                }
                .supporter-list {
                    column-count: 1; /* 1-column on Mobile */
                }
                .floating-donate-widget {
                    display: block;
                    position: fixed;
                    bottom: 15px;
                    right: 15px;
                    z-index: 9999;
                    transform: scale(0.45);
                    transform-origin: bottom right;
                    transition: opacity 0.3s ease-in-out;
                    opacity: 0;
                    pointer-events: none; /* Prevents invisible clicks */
                }
                .floating-donate-widget.visible {
                    opacity: 1;
                    pointer-events: auto;
                }
            }

            .coffee-link {
                color:rgb(183, 190, 202);
                text-decoration: none;
                font-size: 14px;
                margin-top: 40px;
                opacity: 1.0;
                transition: opacity 0.2s;
            }
            .coffee-link:hover { opacity: 1; color: #FFDD00; }
        `}</style>

        <div className="ContentWrapper CustomScroll" style={{ flex: 1, overflowY: 'auto', padding: '20px 20px 100px 20px' }}>
            
            <h1 className='page-header-title'>Support Bridge Brawl!</h1>

            <div className="donations-grid">
                
                {/* --- LEFT CARD: MAIN DONATION --- */}
                <div ref={mainCtaRef} className="GlassCard" style={{ flex: '2 1 auto', minWidth: '300px', width: '100%', height: 'auto' }}>
                    <div style={{ padding: '25px' }}>
                         <h3 style={{ color: '#FFD700', fontSize: 18, marginBottom: 15, textTransform: 'uppercase', letterSpacing: 1, textAlign: 'center'}}>
                            Donate to grow the Prize Pool and add to the hype!
                        </h3>
                        <div 
                            className="RichTextContent"
                            style={{ color: '#E0E0E0', lineHeight: '1.6', fontSize: '15px', marginBottom: 20, textAlign: 'left' }}
                            dangerouslySetInnerHTML={{ __html: donationsContent?.text || "<p>Help us grow the prize pool!</p>" }}
                        />
                        <div style={{ transform: 'scale(0.95)', transformOrigin: 'top center' }}>
                            <GoFundMeEmbed type="medium" />
                        </div>
                    </div>
                </div>

                {/* --- RIGHT CARD: SUPPORTER WALL (SMALLER) --- */}
                <div className="GlassCard" style={{ flex: '1 1 auto', minWidth: '280px', width: '100%', height: 'auto' }}>
                    <div style={{ padding: '25px' }}>
                        <h3 style={{ color: '#FFD700', fontSize: 16, marginBottom: 15, textTransform: 'uppercase', letterSpacing: 1, textAlign: 'center'}}>
                            Thank you to all of our
                            Supporters!
                        </h3>
                        <div 
                            className="RichTextContent supporter-list"
                            // style={{ color: '#A0AEC0', lineHeight: '1.6', fontSize: '13px', textAlign: 'left' }}
                            dangerouslySetInnerHTML={{ __html: thankYouText }}
                        />
                        <div style={{ color: '#ffffff', fontSize: '16px', fontWeight: 'bold', textAlign: 'center', marginTop: '10px' }}>
                            And Many Anonymous Donors!
                        </div>
                    </div>
                </div>

            </div>

            {/* --- BOTTOM LINK: COFFEE --- */}
            <div style={{ textAlign: 'center', position: 'relative', zIndex: 10, padding: '20px 0 40px 0' }}>
                <a 
                    href="https://www.buymeacoffee.com/isaacbstone" 
                    target="_blank" 
                    rel="noreferrer" 
                    className="coffee-link"
                >
                    ☕ Buy the organizers a coffee
                </a>
            </div>
            <div className={`floating-donate-widget ${showFloater ? 'visible' : ''}`}>
                <GoFundMeEmbed type="medium" />
            </div>

        </div>
    </div>
  );
};

export default Donations;